(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurMapController', ReleveCompteurMapController);

    ReleveCompteurMapController.$inject = ['$filter', '$stateParams', '$timeout', 'Agence', 'ReleveCompteur'];

    function ReleveCompteurMapController($filter, $stateParams, $timeout, Agence, ReleveCompteur) {
        var vm = this;

        vm.activePointKey = null;
        vm.areaGeometry = null;
        vm.filteredRows = [];
        vm.mapPoints = [];
        vm.mapRefreshToken = 0;
        vm.openContractPopup = openContractPopup;
        vm.openMeterPopup = openMeterPopup;
        vm.openReadingPopup = openReadingPopup;
        vm.releveCompteur = {};
        vm.rows = [];
        vm.showContractPopupAction = showContractPopupAction;
        vm.showContracts = true;
        vm.showMeterPopupAction = showMeterPopupAction;
        vm.showMeters = true;
        vm.showReadingPassage = true;
        vm.showReadingPopupAction = showReadingPopupAction;
        vm.showReadingTime = true;
        vm.showReadings = true;
        vm.updateVisibility = updateVisibility;

        if ($stateParams.id) {
            ReleveCompteur.get({id: $stateParams.id}, function(result) {
                vm.releveCompteur = result;
                vm.rows = buildRows(result);
                updateVisibility();
                loadAgencyGeometry(result.agenceId);
            });
        }

        function updateVisibility() {
            vm.activePointKey = null;
            vm.filteredRows = vm.rows.filter(function(row) {
                return (vm.showReadings && row.hasReadingPoint) ||
                    (vm.showContracts && row.hasContractPoint) ||
                    (vm.showMeters && row.hasMeterPoint);
            });

            vm.mapPoints = buildVisiblePoints(vm.filteredRows);
            vm.mapRefreshToken += 1;
        }

        function buildRows(releveCompteur) {
            var rows = [];
            var rowIndex = 0;

            angular.forEach(releveCompteur.clusterReleveCompteurDTO || [], function(clusterDto) {
                angular.forEach(clusterDto.ligneReleveCompteur || [], function(line) {
                    rows.push(buildRow(line, releveCompteur, false, rowIndex));
                    rowIndex += 1;
                });
            });

            angular.forEach(releveCompteur.listLigneReleveCompteurBulkMeter || [], function(line) {
                rows.push(buildRow(line, releveCompteur, true, rowIndex));
                rowIndex += 1;
            });

            rows.sort(function(a, b) {
                return compareOrder(a.orderTime, b.orderTime, a.rowIndex, b.rowIndex);
            });

            return rows;
        }

        function buildRow(line, releveCompteur, isBulkMeter, rowIndex) {
            var readingCoords = buildCoords(line.coordLat, line.coordLon);
            var contractCoords = buildCoords(line.lat, line.lon);
            var meterCoords = isBulkMeter ?
                buildCoords(line.bulkMeter && line.bulkMeter.latitude, line.bulkMeter && line.bulkMeter.longitude) :
                buildCoords(line.individualMeter && line.individualMeter.latitude, line.individualMeter && line.individualMeter.longitude);
            var orderTime = resolveOrderTime(line.readingDate, releveCompteur.dateReleve);
            var timeLabel = formatDate(line.readingDate, releveCompteur.dateReleve);
            var meterNumber = isBulkMeter ? (line.bulkMeter ? line.bulkMeter.numeroSerie : '') : (line.individualMeter ? line.individualMeter.numeroSerie : '');
            var valueLabel = buildReadingLabel(line);
            var hasRecordedReading = hasRecordedReadingValue(line);

            return {
                contractGpsLabel: formatCoordinateLabel(contractCoords),
                contractId: line.idContrat,
                contractPoint: contractCoords ? {
                    dateLabel: timeLabel,
                    focusZoom: 17,
                    key: 'contract-' + line.idLigneReleveCompteur,
                    kind: 'contract',
                    lat: contractCoords.lat,
                    lon: contractCoords.lon,
                    subtitle: meterNumber,
                    title: line.referenceContrat || line.nomContrat || '-',
                    valueLabel: valueLabel
                } : null,
                contractReference: line.referenceContrat || line.nomContrat || '-',
                hasContractPoint: !!contractCoords,
                hasRecordedReading: hasRecordedReading,
                hasMeterPoint: !!meterCoords,
                hasReadingPoint: !!readingCoords,
                id: line.idLigneReleveCompteur,
                isBulkMeter: isBulkMeter,
                meterGpsLabel: formatCoordinateLabel(meterCoords),
                meterId: isBulkMeter ? (line.bulkMeter ? line.bulkMeter.id : null) : (line.individualMeter ? line.individualMeter.id : null),
                meterNumber: meterNumber,
                meterPath: isBulkMeter ? '#/bulk-meter/' + (line.bulkMeter ? line.bulkMeter.id : '') : '#/individual-meter/' + (line.individualMeter ? line.individualMeter.id : ''),
                meterPoint: meterCoords ? {
                    dateLabel: timeLabel,
                    focusZoom: 17,
                    hasRecordedReading: hasRecordedReading,
                    key: 'meter-' + line.idLigneReleveCompteur,
                    kind: 'meter',
                    lat: meterCoords.lat,
                    lon: meterCoords.lon,
                    subtitle: line.referenceContrat || line.nomContrat || '-',
                    title: meterNumber,
                    valueLabel: valueLabel
                } : null,
                orderTime: orderTime,
                rowIndex: rowIndex,
                readingPoint: readingCoords ? {
                    dateLabel: timeLabel,
                    focusZoom: 17,
                    hasRecordedReading: hasRecordedReading,
                    key: 'reading-' + line.idLigneReleveCompteur,
                    kind: 'reading',
                    lat: readingCoords.lat,
                    lon: readingCoords.lon,
                    orderTime: orderTime,
                    subtitle: meterNumber,
                    title: line.referenceContrat || line.nomContrat || '-',
                        valueLabel: valueLabel
                } : null,
                readingGpsLabel: formatCoordinateLabel(readingCoords, line.coordPrecision),
                timeLabel: timeLabel,
                valueLabel: valueLabel
            };
        }

        function buildVisiblePoints(rows) {
            var points = [];
            var readingSequence = 0;

            angular.forEach(rows || [], function(row) {
                if (vm.showReadings && row.readingPoint) {
                    readingSequence += 1;
                    points.push(buildReadingPoint(row, readingSequence));
                }

                if (vm.showContracts && row.contractPoint) {
                    points.push(buildContractPoint(row));
                }

                if (vm.showMeters && row.meterPoint) {
                    points.push(buildMeterPoint(row));
                }
            });

            return points;
        }

        function buildReadingPoint(row, readingSequence) {
            var point = angular.copy(row.readingPoint);
            point.sequence = readingSequence;
            point.markerHtml = buildReadingMarkerHtml(readingSequence, row.timeLabel, row.hasRecordedReading);
            point.iconSize = [68, vm.showReadingTime ? 54 : 36];
            point.iconAnchor = [18, 18];
            point.popupAnchor = [0, -16];
            return point;
        }

        function buildContractPoint(row) {
            var point = angular.copy(row.contractPoint);
            point.markerHtml = '<div style="' +
                'background:#2f855a;color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">C</div>';
            point.iconSize = [24, 24];
            point.iconAnchor = [12, 12];
            point.popupAnchor = [0, -12];
            return point;
        }

        function buildMeterPoint(row) {
            var point = angular.copy(row.meterPoint);
            var backgroundColor = row.hasRecordedReading ? '#2f855a' : '#c05621';
            point.markerHtml = '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">M</div>';
            point.iconSize = [24, 24];
            point.iconAnchor = [12, 12];
            point.popupAnchor = [0, -12];
            return point;
        }

        function buildReadingMarkerHtml(readingSequence, timeLabel, hasRecordedReading) {
            var badgeLabel = vm.showReadingPassage ? String(readingSequence) : 'L';
            var backgroundColor = hasRecordedReading ? '#2f855a' : '#c05621';
            var html = '<div style="display:flex;flex-direction:column;align-items:center;">' +
                '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:18px;' +
                'min-width:30px;height:30px;line-height:26px;text-align:center;font-weight:bold;' +
                'padding:0 6px;box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' +
                escapeHtml(badgeLabel) +
                '</div>';

            if (vm.showReadingTime && timeLabel) {
                html += '<div style="' +
                    'margin-top:3px;background:rgba(255,255,255,0.92);color:#1a202c;border-radius:10px;' +
                    'padding:2px 6px;font-size:10px;line-height:1.2;white-space:nowrap;' +
                    'box-shadow:0 1px 3px rgba(0,0,0,0.25);">' + escapeHtml(timeLabel) + '</div>';
            }

            html += '</div>';
            return html;
        }

        function openReadingPopup(row) {
            if (!row || !row.readingPoint) {
                return;
            }

            focusPoint(row.readingPoint.key);
        }

        function openContractPopup(row) {
            if (!row || !row.contractPoint) {
                return;
            }

            focusPoint(row.contractPoint.key);
        }

        function openMeterPopup(row) {
            if (!row || !row.meterPoint) {
                return;
            }

            focusPoint(row.meterPoint.key);
        }

        function focusPoint(pointKey) {
            vm.activePointKey = null;
            vm.mapRefreshToken += 1;

            $timeout(function() {
                vm.activePointKey = pointKey;
                vm.mapRefreshToken += 1;
            }, 0);
        }

        function showReadingPopupAction(row) {
            return vm.showReadings && row && row.hasReadingPoint;
        }

        function showContractPopupAction(row) {
            return vm.showContracts && row && row.hasContractPoint;
        }

        function showMeterPopupAction(row) {
            return vm.showMeters && row && row.hasMeterPoint;
        }

        function loadAgencyGeometry(agenceId) {
            vm.areaGeometry = null;

            if (!agenceId) {
                return;
            }

            Agence.get({id: agenceId}, function(agence) {
                vm.areaGeometry = agence ? agence.geographicCoord : null;
            });
        }

        function resolveOrderTime(readingDate, fallbackDate) {
            if (readingDate) {
                return new Date(readingDate).getTime();
            }
            if (fallbackDate) {
                return new Date(fallbackDate).getTime();
            }
            return 0;
        }

        function formatDate(readingDate, fallbackDate) {
            if (readingDate) {
                return $filter('date')(readingDate, 'shortTime');
            }
            if (fallbackDate) {
                return $filter('date')(fallbackDate, 'mediumDate');
            }
            return '';
        }

        function buildReadingLabel(line) {
            if (line.valeurReleve !== null && line.valeurReleve !== undefined && line.valeurReleve !== '') {
                return $filter('translate')('wamasysApp.releveCompteur.map.reading') + ': ' + line.valeurReleve;
            }
            if (line.casNonReleve && line.casNonReleve.libelle) {
                return $filter('translate')('wamasysApp.releveCompteur.map.nonReading') + ': ' + line.casNonReleve.libelle;
            }
            return $filter('translate')('wamasysApp.releveCompteur.map.noReading');
        }

        function hasRecordedReadingValue(line) {
            return line && line.valeurReleve !== null && line.valeurReleve !== undefined && line.valeurReleve !== '';
        }

        function buildCoords(latValue, lonValue) {
            var lat = parseCoordinate(latValue);
            var lon = parseCoordinate(lonValue);

            if (lat === null || lon === null) {
                return null;
            }

            return {
                lat: lat,
                lon: lon
            };
        }

        function formatCoordinateLabel(coords, precision) {
            if (!coords) {
                return '-';
            }

            var label = $filter('number')(coords.lat, 6) + ', ' + $filter('number')(coords.lon, 6);

            if (precision !== null && precision !== undefined && precision !== '') {
                label += ' (' + $filter('number')(precision, 1) + ' m)';
            }

            return label;
        }

        function compareOrder(firstTime, secondTime, firstIndex, secondIndex) {
            if (firstTime !== secondTime) {
                return firstTime - secondTime;
            }

            return firstIndex - secondIndex;
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
    }
})();
